import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import SilentSubmitHandler from '../SilentSubmitHandler';
import ModalPreviewDocument from '../../../../common/components/ModalPreviewDocument';
import Form_10View from './Form_10-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {useRouteMatch} from 'react-router-dom';
import {pathnames as P} from 'common/constants/pathnames';
import {addComaRoundDecimals, limitDataLength} from 'common/utils/form/limitValueLength';
import {isBankShumaTypeID} from '../../../../common/constants/shumaType';
import {uploadingProgress} from '../../../../common/utils/form/uploadingProgress';
import ButtonSubmitForm from '../ButtonSubmitForm';
import SpinnerContainer from '../../../../common/components/SpinnerContainer';

const Form_10 = ({
                   submitStep,
                   updateCalcWeights,
                   stepData,
                   getShumaStepStatus,
                   showGlobalErrorMessage,
                   getStepData,
                   shumaTypeID
                 }) => {
  const [reinit, setReinit] = useState(true);
  const [progress, setProgress] = useState(0);
  const [showUploadingFilePopUp, setShowUploadingFilePopUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    totalRegisteredArea,
    totalRoomCount,
    totalPrice,
    averageSqmPrice,
    averageRoomPrice,
    averageRoomSq,
    averageSqmPriceSD,
    averageSqmPriceUpperBorder,
    averageSqmPriceLowerBorder,
    deviationPercent,
    housePermitArea,
    houseBalconyOpenPermitArea,
    houseBalconyClosedPermitArea,
    houseYardPermitArea,
    houseRoofPermitArea,
    houseStoragePermitArea,
    housePermitAreaWeightedValue,
    permitSqmOpenBalconyWeightedValue,
    permitSqmClosedBalconyWeightedValue,
    permitSqmYardWeightedValue,
    permitSqmRoofWeightedValue,
    permitSqmStorageWeightedValue,
    housePermitAreaAdjusted,
    permitSqmOpenBalconyAreaAdjusted,
    permitSqmClosedBalconyAreaAdjusted,
    permitSqmYardAreaAdjusted,
    permitSqmRoofAreaAdjusted,
    permitSqmStorageAreaAdjusted,
    permitSqmTotalAdjustedArea,
    permitSqmGeneralAdjustmentValue,
    permitSqmAveragePriceAdjusted,
    estimatePriceMethod1,
    houseRegisteredArea,
    houseBalconyOpenRegisteredArea,
    houseBalconyClosedRegisteredArea,
    houseYardRegisteredArea,
    houseRoofRegisteredArea,
    houseStorageRegisteredArea,
    registeredRoomHouseRegisteredAreaWeightedValue,
    registeredRoomOpenBalconyWeightedValue,
    registeredRoomClosedBalconyWeightedValue,
    registeredRoomYardWeightedValue,
    registeredRoomRoofWeightedValue,
    registeredRoomStorageWeightedValue,
    houseRegisteredAreaAdjusted,
    registeredRoomOpenBalconyAreaAdjusted,
    registeredRoomClosedBalconyAreaAdjusted,
    registeredRoomYardAreaAdjusted,
    registeredRoomRoofAreaAdjusted,
    registeredRoomStorageAreaAdjusted,
    registeredRoomTotalAdjustedArea,
    averageRoomCount,
    registeredRoomGeneralAdjustmentValue,
    registeredRoomAveragePriceAdjusted,
    estimatePriceMethod2,
    registeredSqmHouseRegisteredAreaWeightedValue,
    registeredSqmOpenBalconyWeightedValue,
    registeredSqmClosedBalconyWeightedValue,
    registeredSqmYardWeightedValue,
    registeredSqmRoofWeightedValue,
    registeredSqmStorageWeightedValue,
    registeredSqmOpenBalconyAreaAdjusted,
    registeredSqmClosedBalconyAreaAdjusted,
    registeredSqmYardAreaAdjusted,
    registeredSqmRoofAreaAdjusted,
    registeredSqmStorageAreaAdjusted,
    registeredSqmTotalAdjustedArea,
    registeredSqmGeneralAdjustmentValue,
    registeredSqmAverageUpperBorderPriceAdjusted,
    estimatePriceMethod3,
    estimatePriceFinal,
    houseJointHomeRegistered,
    permitSqmFinalWeightedScale,
    registeredRoomFinalWeightedScale,
    registeredSqmFinalWeightedScale,
    ...rest
  } = stepData;

  const initialValues = {
    totalRegisteredArea: totalRegisteredArea ? addComaRoundDecimals(totalRegisteredArea) : '',
    totalRoomCount: totalRoomCount || '',
    totalPrice: totalPrice ? addComaRoundDecimals(totalPrice) : '',
    averageSqmPrice: averageSqmPrice ? addComaRoundDecimals(averageSqmPrice) : '',
    averageRoomPrice: averageRoomPrice ? addComaRoundDecimals(averageRoomPrice) : '',
    averageRoomSq: averageRoomSq || '',
    averageRoomCount: averageRoomCount ? limitDataLength(4)(averageRoomCount) : '',
    averageSqmPriceSD: averageSqmPriceSD ? addComaRoundDecimals(averageSqmPriceSD) : '',
    averageSqmPriceUpperBorder: averageSqmPriceUpperBorder ? addComaRoundDecimals(averageSqmPriceUpperBorder) : '',
    averageSqmPriceLowerBorder: averageSqmPriceLowerBorder ? addComaRoundDecimals(averageSqmPriceLowerBorder) : '',
    deviationPercent: deviationPercent ? deviationPercent.toFixed(2) : '',
    housePermitArea: housePermitArea || '',
    housePermitAreaWeightedValue: housePermitAreaWeightedValue || '',
    housePermitAreaAdjusted: housePermitAreaAdjusted || 0,
    houseBalconyOpenPermitArea: houseBalconyOpenPermitArea || '',
    permitSqmOpenBalconyWeightedValue: permitSqmOpenBalconyWeightedValue || 0,
    permitSqmOpenBalconyAreaAdjusted: permitSqmOpenBalconyAreaAdjusted || 0,
    houseBalconyClosedPermitArea: houseBalconyClosedPermitArea || '',
    permitSqmClosedBalconyWeightedValue: permitSqmClosedBalconyWeightedValue || 0,
    permitSqmClosedBalconyAreaAdjusted: permitSqmClosedBalconyAreaAdjusted || 0,
    houseYardPermitArea: houseYardPermitArea || '',
    permitSqmYardWeightedValue: permitSqmYardWeightedValue || 0,
    permitSqmYardAreaAdjusted: permitSqmYardAreaAdjusted || 0,
    houseRoofPermitArea: houseRoofPermitArea || '',
    permitSqmRoofWeightedValue: permitSqmRoofWeightedValue || 0,
    permitSqmRoofAreaAdjusted: permitSqmRoofAreaAdjusted || 0,
    houseStoragePermitArea: houseStoragePermitArea || '',
    permitSqmStorageWeightedValue: permitSqmStorageWeightedValue || 0,
    permitSqmStorageAreaAdjusted: permitSqmStorageAreaAdjusted || 0,
    permitSqmTotalAdjustedArea: permitSqmTotalAdjustedArea || '',
    permitSqmGeneralAdjustmentValue: permitSqmGeneralAdjustmentValue || 0,
    permitSqmAveragePriceAdjusted: permitSqmAveragePriceAdjusted
      ? addComaRoundDecimals(permitSqmAveragePriceAdjusted) : '',
    estimatePriceMethod1: estimatePriceMethod1
      ? addComaRoundDecimals(estimatePriceMethod1) : '',
    houseRegisteredArea: houseRegisteredArea || '',
    registeredRoomHouseRegisteredAreaWeightedValue: registeredRoomHouseRegisteredAreaWeightedValue || '',
    houseRegisteredAreaAdjusted: houseRegisteredAreaAdjusted || 0,
    houseBalconyOpenRegisteredArea: houseBalconyOpenRegisteredArea || '',
    registeredRoomOpenBalconyWeightedValue: registeredRoomOpenBalconyWeightedValue || 0,
    registeredRoomOpenBalconyAreaAdjusted: registeredRoomOpenBalconyAreaAdjusted || 0,
    houseBalconyClosedRegisteredArea: houseBalconyClosedRegisteredArea || '',
    registeredRoomClosedBalconyWeightedValue: registeredRoomClosedBalconyWeightedValue || 0,
    registeredRoomClosedBalconyAreaAdjusted: registeredRoomClosedBalconyAreaAdjusted || 0,
    houseYardRegisteredArea: houseYardRegisteredArea || '',
    registeredRoomYardWeightedValue: registeredRoomYardWeightedValue || 0,
    registeredRoomYardAreaAdjusted: registeredRoomYardAreaAdjusted || 0,
    houseRoofRegisteredArea: houseRoofRegisteredArea || '',
    registeredRoomRoofWeightedValue: registeredRoomRoofWeightedValue || 0,
    registeredRoomRoofAreaAdjusted: registeredRoomRoofAreaAdjusted || 0,
    houseStorageRegisteredArea: houseStorageRegisteredArea || '',
    registeredRoomStorageWeightedValue: registeredRoomStorageWeightedValue || 0,
    registeredRoomStorageAreaAdjusted: registeredRoomStorageAreaAdjusted || 0,
    registeredRoomTotalAdjustedArea: registeredRoomTotalAdjustedArea || '',
    registeredRoomGeneralAdjustmentValue: registeredRoomGeneralAdjustmentValue || 0,
    registeredRoomAveragePriceAdjusted: registeredRoomAveragePriceAdjusted
      ? addComaRoundDecimals(registeredRoomAveragePriceAdjusted) : '',
    estimatePriceMethod2: estimatePriceMethod2
      ? addComaRoundDecimals(estimatePriceMethod2) : '',
    registeredSqmHouseRegisteredAreaWeightedValue: registeredSqmHouseRegisteredAreaWeightedValue || '',
    registeredSqmOpenBalconyWeightedValue: registeredSqmOpenBalconyWeightedValue || 0,
    registeredSqmOpenBalconyAreaAdjusted: registeredSqmOpenBalconyAreaAdjusted || 0,
    registeredSqmClosedBalconyWeightedValue: registeredSqmClosedBalconyWeightedValue || 0,
    registeredSqmClosedBalconyAreaAdjusted: registeredSqmClosedBalconyAreaAdjusted || 0,
    registeredSqmYardWeightedValue: registeredSqmYardWeightedValue || 0,
    registeredSqmYardAreaAdjusted: registeredSqmYardAreaAdjusted || 0,
    registeredSqmRoofWeightedValue: registeredSqmRoofWeightedValue || 0,
    registeredSqmRoofAreaAdjusted: registeredSqmRoofAreaAdjusted || 0,
    registeredSqmStorageWeightedValue: registeredSqmStorageWeightedValue || 0,
    registeredSqmStorageAreaAdjusted: registeredSqmStorageAreaAdjusted || 0,
    registeredSqmTotalAdjustedArea: registeredSqmTotalAdjustedArea || '',
    registeredSqmGeneralAdjustmentValue: registeredSqmGeneralAdjustmentValue || 0,
    registeredSqmAverageUpperBorderPriceAdjusted: registeredSqmAverageUpperBorderPriceAdjusted
      ? addComaRoundDecimals(registeredSqmAverageUpperBorderPriceAdjusted) : '',
    estimatePriceMethod3: estimatePriceMethod3 ? addComaRoundDecimals(estimatePriceMethod3) : '',
    estimatePriceFinal: estimatePriceFinal ? addComaRoundDecimals(estimatePriceFinal) : '',
    estimatePriceFinalRounded: '',
    permitSqmFinalWeightedScale: permitSqmFinalWeightedScale || 0,
    registeredRoomFinalWeightedScale: registeredRoomFinalWeightedScale || 0,
    registeredSqmFinalWeightedScale: registeredSqmFinalWeightedScale || 0,
    ...rest
  };
  const {params: {shumaId, formId: stepId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const nextStep = (isBankShumaTypeID(shumaTypeID)) ? 12 : 8;

  const validate = values => checkRequiredValues(values, {});

  const submitFormDataWithoutFormReinitialization = (values) => {
    const {estimatePriceFinalRounded} = values;
    const data = {
      shumaID: shumaId,
      estimatePriceFinalRounded: estimatePriceFinalRounded ? estimatePriceFinalRounded : null,
    };

    setReinit(false);  //https://github.com/formium/formik/issues/2369
    return submitStep({step: 10, data})
      .then(() => setReinit(true))
  };

  const submitWithoutFormReinitialization = (calcTypeId, newValue) => {
    const data = {
      shumaID: shumaId,
      calcTypeID: calcTypeId,
      newValue: newValue ? newValue : 0,
    };

    setReinit(false);  //https://github.com/formium/formik/issues/2369
    return updateCalcWeights({data})
      .then(() => setReinit(true))
  };

  const handleDataSubmit = (calcTypeId, newValue) => {
    setShowUploadingFilePopUp(true);
    submitWithoutFormReinitialization(calcTypeId, newValue)
      .then(() => uploadingProgress(setProgress))
      .then(() => getStepData({shumaId, stepId}))
      .then(() => getShumaStepStatus({shumaId, resetValues: false}))
      .catch((err) => showGlobalErrorMessage(err.message))
      .then(() => {
        setTimeout(() => {
          setShowUploadingFilePopUp(false)
        }, 300)
      })
  };

  const handleFormDataSubmit = (values, shumaId, dirty) => {
    if (dirty) {
      submitFormDataWithoutFormReinitialization(values)
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const handleDataSubmitForPreview = (values, shumaId, dirty) => {
    if (dirty) {
      submitFormDataWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const handleDataSubmitForSave = (values, shumaId, dirty) => {
    if (dirty) {
      setLoading(true);
      submitFormDataWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message))
        .finally(() => setLoading(false));
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={() => {
      }}
      enableReinitialize={reinit}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          <SilentSubmitHandler
            onSubmit={handleFormDataSubmit}
            values={formikProps.values}
            shumaId={shumaId}
            dirty={formikProps.dirty}
          />
          <ButtonSubmitForm
            onClick={() => {
              handleDataSubmitForSave(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
            disabled={!formikProps.dirty}
          />
          <ModalPreviewDocument
            submitOnOpen={() => {
              handleDataSubmitForPreview(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
          />
          {loading ? <SpinnerContainer/> : (
            <Form_10View
              {...formikProps}
              prevPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 9)}
              nextPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, nextStep)}
              handleDataSubmit={handleDataSubmit}
              showUploadingFilePopUp={showUploadingFilePopUp}
              progress={progress}
              houseJointHomeRegistered={houseJointHomeRegistered}
              shumaTypeID={shumaTypeID}
            />
          )}
        </>
      )}
    </Formik>
  )
};

Form_10.propTypes = {
  stepData: PropTypes.object,
};

export default Form_10;
